var OCS = OCS || {};
OCS.Functions = OCS.Functions || {};
OCS.Functions.get_ocs_api_subdomain = function () {
    return (OCS.ENVIRONMENT === 'DEVELOPMENT' || OCS.ENVIRONMENT === 'STAGING') ? 'xapi' : 'api';
};
OCS.Functions.get_ocs_domain = function () {
    return OCS.domain.split('.').slice(-2).join('.');
};
OCS.Functions.get_ocs_feeds_domain = function () {
    return (OCS.ENVIRONMENT === 'PRODUCTION') ? 'feeds.prod.mesonet.org' : (OCS.ENVIRONMENT === 'STAGING') ? 'feeds.test.mesonet.org' : 'feeds.dev.ok.mesonet.us';
};
OCS.Functions.get_dataset_from_node = function(node_dataset) {
    var dataset_obj, dataset_name, i;
    var dataset_names = Object.keys(OCS.Datasets);
    for(i = 0; i < dataset_names.length; i++) {
        dataset_name = dataset_names[i];
        dataset_obj = OCS.Datasets[dataset_name];
        if(dataset_obj && (dataset_name === node_dataset || dataset_obj.get_node_dataset_name() === node_dataset)) {
            return dataset_obj;
        }
    }
    return false;
};